<template>
    <div>
        <collection-list-link :listLayout="listLayout" :paginationData="filterSet.page" :collectionData="List"></collection-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page" :listLength="List.length"
                         :finishGetList="finishGetList"  v-if="filterSet.page.total"></pagination-link>
    </div>
</template>

<script>
import CollectionListLink from "@/components/collection/CollectionListLink";
import collectionUtil from "@/components/collection/collectionUtil";
import PaginationLink from "@/components/collection/PaginationLink";
import listMixins from "@/mixins/listMixins"
import filterMixins from "@/mixins/filterMixins";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/utils/event-bus";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";
import boardValidator from "@/mixins/validators/boardValidator";

const {filterConfig} = collectionUtil;

export default {
    name: "CollectionListComponent",
    mixins: [alertMixins, collectionUtil, filterMixins, listMixins, awsS3FileUpload, boardValidator],
    components: {
      CollectionListLink,
      PaginationLink,
    },
    provide() {
        return {
          setPage: this.setPage,
          setFilter: this.setFilter,
          setCollectionListData: this.setData,
          collectionListDelete: this.runDeleteConfirm,
          writeCollection: this.writeCollection,
        }
    },
    inject: ['changeLoading'],
    props: {
      collectionType: {default: ''},
      memberKey: {default: 0},
    },
    data() {
        return {
          getFunc: '',
          listLayout: '',
          paginationLayout: '',
          writeFunc: '',
          writeSuccessType: '',
          detailApiParamsSet:{},
          DeleteClass: null,
          background: [],
          thumbnail: [],
          parsingData: '',
        }
    },
    created() {
      this.initConfig();
      this.setFilterConfig(filterConfig);
      this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
      this.getList(true);
    },
    beforeDestroy() {

    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnCollectionConfig(this.collectionType);
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.pageRow = config.pageRow;
            this.keyName = config.keyName;
            this.fileInfo = config.fileInfo;
            this.writeFunc= config.writeFunc;
            this.parsingData = config.parsingData;
            this.writeApiParamSet = config.writeApiParamSet

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.deleteKeyName = config.deleteKeyName;
            this.newDeleteClass();

            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
              this.pageRow = config.pageRow;
              this.filterSet.page.size = config.pageRow;
              this.pageClass.setterPage('size', this.pageRow);
            }

            let params = JSON.parse(JSON.stringify(this.listApiParamSet));

            if (!util.isEmpty(this.memberKey)) {
              // params.no = this.memberKey
              params[this.keyName] = this.memberKey
            }
            let listOptions = {
              url: this.$api.$collection[this.getFunc],
              defaultParams: params,
            }
            this.initList('api', listOptions);
        },
        newDeleteClass() {
          if (!util.isEmpty(this.deleteFunc)) {
            let deleteOptions = {
              func: this.$api.$collection[this.deleteFunc],
              apiParamSet: this.deleteApiParamsSet,
              keyName: this.deleteKeyName,
              successType: this.deleteSuccessType,
              errorTypes: this.deleteFailTypes,
              afterFunc: this.deleteAfterFunc,
            }
            this.DeleteClass = new DeleteClass(deleteOptions);
          }
        },
        runDeleteConfirm(key, idx) {
          this.createConfirm({
            content: '정말 삭제하시겠습니까?',
            confirm: () => {
              this.runDelete(key);
            }
          })
        },
        runDelete(key) {
          EventBus.$emit('changeLoading', true)
          this.DeleteClass.runDelete(key);
        },
        deleteAfterFunc() {
          EventBus.$emit('changeLoading', false)

          this.createAlert({
            content: '삭제되었습니다.',
            hide: () => {
              this.getList()
            }
          })
        },
        writeCollection(params) {
          this.thumbnail = params.thumbnail
          this.background = params.background
          this.deleteFiles = params.deleteFiles

          console.log(this.deleteFiles)

          if(!util.isEmpty(params.deleteFiles)){
            this.runS3ApiDelete(params.deleteFiles)
          }
          delete params.thumbnail;
          delete params.background;
          delete params.deleteFiles

          try {
            this.$api.$collection[this.writeFunc](params).then(res => res.Data.Result).then(res => {
              let type = this.returnWriteCollectionType(res.Info.type)
              if (type === true) {
                let key = ''
                key = params.hasOwnProperty('c_idx') ? params.c_idx : res.List.c_idx
                this.uploadImage(key)
              } else {
                this.errorAlert(type)
              }
            })
          } catch (e) {
            console.log(e)
          }
        },
        returnWriteCollectionType(type) {
          switch (type){
            case 1 :
              return true
            default :
              return "저장에 실패하였습니다."
          }
        },
        uploadImage(key) {
          let checkFile = (!util.isEmpty(this.thumbnail) && !util.isEmpty(this.background))
              && (this.thumbnail.filter(file => file.hasOwnProperty('raw')).length > 0 &&
                  this.background.filter(file => file.hasOwnProperty('raw')).length > 0)
          if (checkFile) {
            this.runUploadFileInfo(this.fileInfo, 0, key).then(res=>{
                  this.afterFunc();
              }
            )
          }else {
            this.afterFunc();
          }
        },
        afterFunc(){
          this.createAlert({
            content: '저장되었습니다.',
            hide: () => {
              this.getList()
            }
          })
        }
      // uploadImage(data) {
      //   EventBus.$emit('changeLoading', true)
      //
      //   if (!util.isEmpty(this.deleteFiles)) {
      //     this.runS3ApiDelete(this.deleteFiles)
      //   }
      //   if (!util.isEmpty(this.fileInfo)) {
      //     let key = data;
      //     this.setMultiFileUpload(key, this.fileInfo)
      //   }
      // },
      // setMultiFileUpload(key, fileInfo) {
      //   EventBus.$emit('changeLoading', true)
      //
      //   this.runS3ApiUpload(fileInfo, 0, key)
      // },
    },
    watch: {},
}
</script>

<style scoped>

</style>
